import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";
import { MemberBalancePayload, MemberBalanceResType } from "types/user";

import {
  GetProfilePayload,
  GetProfileResponse,
  UpdateProfilePayload,
  UpdateProfileResponse,
} from "./type";
import { AvatarPayload } from "./type";

export const UserApi = {
  async getProfile(typename: string, payload: GetProfilePayload) {
    const response = await axiosRequest.post<GetProfileResponse>(
      "/",
      payloadHelper("MemberDetail", typename, payload)
    );
    return response.data;
  },

  async getMemberBalance(typename: string, payload: MemberBalancePayload) {
    const response = await axiosRequest.post<MemberBalanceResType>(
      "",
      payloadHelper("GetBalanceDV", typename, payload)
    );

    return response.data;
  },

  async updateProfile(typename: string, payload: UpdateProfilePayload) {
    const { data } = await axiosRequest.post<UpdateProfileResponse>(
      "/",
      payloadHelper("UpdateMemberDetail", typename, payload)
    );
    return data;
  },
};

export const UpdateAvatarApi = {
  async updateAvatarUser(username: string, payload: AvatarPayload) {
    const response = await axiosRequest.post<ApiResponse>(
      "",
      payloadHelper("UpdateAvatar", username, payload)
    );
    return response.data;
  },
};
